import axios from 'axios';
import { get } from 'lodash-es';

async function getPackageId(catalogID) {
  // Fetch the packageID from the summary, since we need this to upload the spreadsheet
  try {
    const summaryResp = await axios(`/cps/app/catalog/${catalogID}`);
    const packageID = get(summaryResp, 'data.data.sessionDefinition.packageID', null);
    return packageID;
  } catch (e) {
    return null;
  }
}

export default getPackageId;
